/* eslint-disable no-param-reassign */

import { createSlice } from "@reduxjs/toolkit";
import role from "../config/App-role";
import urls from "../api/project/ApiUrls";

const initialState = {
  // displayName: "demo-user",
  // email: "demo@demo.com",
  // isAnonymous: false,
  role: role.anonymous,
  locale: urls.locale_lang.LOCALE_DEFAULT,
  authority: "free", // e.g. "free", "advance", "enterprise"
  refreshUserInfo: false,
  refreshUserGroups: false,
  token: null,
  group: {
    // uid: "ac",
    // displayName: "Alpha camp",
    // members: {
    //   aaaaaaa: {isMember: true, role: "admin"},
    //   bbbbbbb: {isMember: true, role: "editor"},,
    //   ccccccc: {isMember: true, role: "editor"},,
    //   ddddddd: {isMember: true, role: "editor"},,
    // },
  },
  // 這邊的資料結構與 realtime database 的 groups 相同
  groups: {
    // ac: {
    //   uid: "asdfasdfsfsadf",
    //   isMember: true,
    //   role: "editor",
    //   members: {}
    //   files: {}
    // },
    // tt: {
    //   uid: "asdfasdfsfsadf",
    //   isMember: true,
    //   role: "editor",
    //   members: {}
    //   files: {}
    // },
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserLocale: (state, action) => {
      state.locale = action.payload;
    },
    setUserToken: (state, action) => {
      state.token = action.payload;
    },
    firebaseLoginUser: (state, action) => {
      state = { ...action.payload };
    },
    firebaseLogoutUser: (state, action) => {
      state = { ...initialState };
    },
    userRefreshUserInfo: (state, action) => {
      state.refreshUserInfo = action.payload;
    },
    userRefreshUserGroups: (state, action) => {
      state.refreshUserGroups = action.payload;
    },
    userSetCurGroup: (state, action) => {
      state.group = action.payload;
    },
    userSetGroups: (state, action) => {
      state.groups = action.payload;
    },
    userSetRole: (state, action) => {
      state.role = action.payload;
    },
  },
});

export const {
  setUserLocale,
  setUserToken,
  firebaseLoginUser,
  firebaseLogoutUser,
  userRefreshUserGroups,
  userRefreshUserInfo,
  userSetRole,
  userSetCurGroup,
  userSetGroups,
} = userSlice.actions;

export default userSlice.reducer;
